import { render, staticRenderFns } from "./ShoppingCartSidebar.vue?vue&type=template&id=953d3a9c&scoped=true"
import script from "./ShoppingCartSidebar.vue?vue&type=script&lang=js"
export * from "./ShoppingCartSidebar.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCartSidebar.vue?vue&type=style&index=0&id=953d3a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953d3a9c",
  null
  
)

export default component.exports